export default __webpack_public_path__ + "static/media/landing-dog.066f499b.png";